module.exports = __webpack_public_path__ + "img/event3.438c217a.png";